module.exports = __webpack_public_path__ + "static/media/fund-campaign-icon.f059397a.svg";